import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, Divider } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsModal from './SettingsModal';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [settingsOpen, setSettingsOpen] = useState(false);
  
  const { user, logout } = useAuth();
  
  const userName = user?.name || 'ゲスト';
  const userRole = user?.role || 'guest';

  const handleUserNameClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout();
  };

  const handleOpenSettings = () => {
    handleClose();
    setSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setSettingsOpen(false);
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6">
            工事予定表
          </Typography>
          <div>
            <Button 
              color="inherit" 
              onClick={handleUserNameClick}
              startIcon={userRole === 'admin' ? <SettingsIcon /> : undefined}
            >
              {userName}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {userRole === 'admin' && (
                <>
                  <MenuItem onClick={handleOpenSettings}>
                    設定
                  </MenuItem>
                  <Divider />
                </>
              )}
              <MenuItem onClick={handleLogout}>
                ログアウト
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      {userRole === 'admin' && (
        <SettingsModal 
          open={settingsOpen} 
          onClose={handleCloseSettings} 
        />
      )}
    </>
  );
};

export default Header;